import { styled } from 'styled-components'
import Alert from '@web-ui-kit/alert'

export const StyledAlert = styled(Alert)`
  && span {
    color: black;
  }
`
